'use strict';

angular.module('shiftTraderApp')
  .service('TempAppStorage', ['$rootScope', '$log',
    function($rootScope, $log) {
      var cache = {};

      $rootScope.$on('flushCaches', function() {
        clear();
      });

      function isValueAtKeyValid(validUntilUnix) {
        return moment.utc().unix() < validUntilUnix;
      }

      function get(key) {
        if (_.has(cache, key)) {
          if (isValueAtKeyValid(cache[key].validUntil)) {
            return cache[key].data;
          }
        }

        return null;
      }

      function set(key, val, expInMinutes) {
        var storedAt = moment.utc();

        cache[key] = {
          data: val,
          storedAt: storedAt.unix(),
          validUntil: moment(storedAt).add(expInMinutes, 'minutes').unix()
        };

        return cache[key].data;
      }

      function remove(key) {
        delete cache[key];
        return true;
      }

      function clear() {
        cache = {};
        return true;
      }

      return {
        get: get,
        set: set,
        remove: remove,
        clear: clear
      };

    }]);
